export const DsAccordionDefaultProps = {
    header: '',
    summary: '',
    TransitionProps: {
        unmountOnExit: true
    }
};
